/**
 * TCR-2224 — ô ĐƠN GIÁ ở bảng dòng hàng POS / màn sửa đơn nhận tối đa 2 chữ số
 * thập phân. Quy ước vi-VN: dấu phẩy là thập phân, dấu chấm là phân cách nghìn
 * (gõ dấu chấm bị bỏ qua — formatter tự chèn).
 *
 * Tách riêng khỏi `moneyParser`/`moneyFormatter` (`utils/format.ts`,
 * `POS/utils/moneyInput.ts`): các ô THANH TOÁN vẫn là đồng nguyên.
 */
const MAX_DECIMALS = 2;
const unitPriceFormat = new Intl.NumberFormat('vi-VN', { maximumFractionDigits: MAX_DECIMALS });

function splitDecimal(raw: string): { intDigits: string; decDigits: string; hasComma: boolean } {
  const [intRaw = '', ...rest] = raw.split(',');
  return {
    intDigits: intRaw.replace(/\D/g, '').replace(/^0+(?=\d)/, ''),
    decDigits: rest.join('').replace(/\D/g, '').slice(0, MAX_DECIMALS),
    hasComma: rest.length > 0,
  };
}

function groupThousands(digits: string): string {
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/** Hiển thị đơn giá: `12345.67` → `12.345,67`, `300000` → `300.000`. */
export function formatUnitPrice(n: number): string {
  return unitPriceFormat.format(n);
}

/** Định dạng chuỗi đang gõ: chèn dấu chấm nghìn, giữ MỘT dấu phẩy, cắt quá 2 chữ số lẻ. */
export function formatUnitPriceInput(raw: string): string {
  const { intDigits, decDigits, hasComma } = splitDecimal(raw);
  if (!intDigits && !hasComma) return '';
  const intPart = groupThousands(intDigits || '0');
  return hasComma ? `${intPart},${decDigits}` : intPart;
}

/** `12.345,67` → `12345.67`. Chuỗi rỗng ⇒ 0. */
export function parseUnitPrice(s: string): number {
  const { intDigits, decDigits } = splitDecimal(s);
  if (!intDigits && !decDigits) return 0;
  return Number(`${intDigits || '0'}.${decDigits || '0'}`);
}

/** TCR-2224 — làm tròn đơn giá/tiền về 2 chữ số lẻ; khử sai số dấu phẩy động (12345.67 × 3 = 37037.009999…). */
export function roundTo2Decimals(n: number): number {
  return Math.round(n * 100) / 100;
}
